<template>
  <div>
    <div v-if="searched_presenters.length > 0 && !loading" class="position-absolute w-50" style="z-index:1; overflow: scroll; max-height: 250px;">
      <ul class="list-group rounded-0 border border-1 border-dark shadow-lg">
        <li v-if="searched_presenters.length > 20 && limit == 20" style="justify-content: space-between;"
          class="list-group-item fs-6 fw-semibold bg-secondary py-1 px-2 d-flex">
          <span>Showing 20 of {{ searched_presenters.length }} results</span>
          <span style="color: #005f9a !important;" @click="limit = searched_presenters.length">{{ $t('network.viewAll') }}</span>
        </li>
        <li v-for="(presenter, index) in sortedArray(searched_presenters.slice(0, limit))" :key="index" :class="[!presenter.is_already_added ? 'bg-light' : '']"
        :role="[!presenter.is_already_added ? 'button' : '']" class="list-group-item btn-link " @click="[ !presenter.is_already_added ? addPresenter(presenter) : '' ] " >
          <span :class="[presenter.is_already_added ? 'text-muted' : '']" class="text-primary">{{ presenter.first_name }} {{ presenter.last_name }}</span>
          <span v-if="presenter.is_already_added" class="badge bg-light border border-primary float-end rounded-3" align="right">{{ $t('already-added') }}</span>
          <br />
          <small class="text-muted"> <i class="fa fa-envelope small"></i> {{ presenter.email }}</small>
        </li>
        <li class="list-group-item btn-link p-0 bg-secondary rounded-0 pt-2 ps-3 text-start">
          <h6 role="button" class="text-dark" @click="addNewUserAsPresenter" v-html="$t('add-as-a-new-user', { user: searchPresenterQuery } )"></h6>
        </li>
      </ul>
    </div>
    <div v-if="loading" class="position-absolute w-50 text-center" style="z-index:1;">
      <ul class="list-group rounded-0 border border-1 border-dark shadow-lg">
        <li class="list-group-item btn-link p-0 bg-secondary py-1 text-center">
          <span role="button" class="fs-6">
            <i class="fas fa-spinner"></i>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import sortBy from 'lodash/sortBy';

export default {
  props: {
    searched_presenters: {
      type: Array,
      default: null,
    },
    network_media_id: {
      type: [String, Number],
      default: null,
    },
    searchPresenterQuery: {
      type: [String, Number],
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 20,
    },
  },
  beforeDestroy() {
    this.limit = 20;
  },
  methods: {
    showEditPresenter(user) {
      console.log(user);
      this.$emit('show-presenter-edit-modal', {
        invitationName: user.text,
        presenterForm: user.presenterModel,
        title: this.$t('network.networkForm.editPresenter'),
        showInviteModal: true,
      });
    },
    showEditUser(user) {
      console.log(user);
      this.$emit('show-user-edit-modal', {
        title: this.$t('ExistingPresenters.edit-user') + user.text,
        userForm: user.user,
        invitationName: user.text,
        showInviteModal: true,
        inInviteMode: false,
        submitText: this.$t('network.auth.editUser'),
      });
    },
    addPresenter(presenter){
      this.$emit('add-media-presenter', presenter);
    },
    removePresenter(presenter){
      this.$emit('remove-media-presenter', presenter, 'PRESENTER');
    },
    addNewUserAsPresenter(){
      this.$emit('add-media-presenter', this.searchPresenterQuery);
    },
    sortedArray(array) {
      return sortBy(array, 'fullname');
    },
  },
};
</script>
<style scoped>
.btn-link:hover{
  /* border: 1px solid rgba(0,0,0,0.3); */
  opacity: 85;
  font-weight: bold;
  text-decoration: none;
  }
</style>
